import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { BodyCaption, BodyPrimary, BodySecondary, } from "../TypographyStyle";
import { COLORS } from "../../constants/Theme";
const getBorderColor = ({ isActive, isInvalid, hightlightInputColor }) => {
    if (isActive) {
        return hightlightInputColor ? hightlightInputColor : COLORS.stroke.brand;
    }
    else if (isInvalid) {
        return COLORS.stroke.negative.vibrant;
    }
    return COLORS.stroke.primary;
};
export const InputWrapper = styled.div `
	border-radius: ${(props) => (props.version === '2.0' ? 8 : 4)}px;
	background: ${(props) => ['disabled', 'read-only', 'disabled-invalid'].includes(props.state)
    ? COLORS.background.base
    : '#fff'};
	border: ${(props) => (props.version === '2.0' ? 0.5 : 1)}px solid
		${(props) => getBorderColor({
    isActive: props.isActive,
    isInvalid: props.isInvalid,
    hightlightInputColor: props.hightlightInputColor,
})};
	${(props) => props.isActive
    ? `box-shadow: inset 0px 0px 0px 1px ${props.hightlightInputColor
        ? props.hightlightInputColor
        : COLORS.stroke.brand};`
    : ''};
	padding: ${(props) => (props.variant === 'small' ? '6px' : '8px')};
	height: ${(props) => props.height || '100%'};
	${(props) => props.variant && ['small', 'x-small'].includes(props.variant)
    ? 'max-height: 44px'
    : 'min-height: 48px'};
	display: flex;
	align-items: center;
	box-sizing: border-box;
	gap: 8px;
	overflow: hidden;

	${(props) => (props.state === 'read-only' ? 'opacity: 0.7' : '')};
	${(props) => (props.state === 'read-only' ? 'pointer-events: none' : '')};
`;
export const IconHolder = styled.div `
	min-height: ${(props) => props.iconSize};
	min-width: ${(props) => props.iconSize};
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
	${(props) => props.isLeft
    ? `margin-left:${props.variant && ['small', 'x-small'].includes(props.variant)
        ? '0px'
        : '8px'}`
    : `margin-right: ${props.variant && ['small', 'x-small'].includes(props.variant)
        ? '0px'
        : '8px'}`};
`;
const inputCss = css `
	flex-grow: 1;
	overflow: hidden;
	height: 100%;

	input,
	textarea {
		display: block;
		width: 100%;
		height: 100%;
		border: none;
		min-height: 24px;
		outline: none;
		font-size: inherit;
		line-height: inherit;
		font-weight: inherit;
		padding: 0px;
		margin: 0px;
		background: transparent;
		&::placeholder {
			font-family: Inter;
			color: ${COLORS.content.placeholder};
		}

		&::-webkit-outer-spin-button,
		&::-webkit-inner-spin-button {
			-webkit-appearance: none;
			margin: 0;
		}
	}

	textarea {
		height: 100%;
		font-family: Inter;
		min-height: 100px;
		resize: none;
	}
`;
export const InputContainer = styled(BodyPrimary) `
	${inputCss};
	${(props) => props.height && props.type !== 'multiline' ? { height: props.height } : {}};

	${(props) => props.autoGrow &&
    props.minHeight &&
    `
	textarea {
		height: ${props.minHeight};
		min-height: ${props.minHeight};
		max-height: ${props.maxHeight || '100px'};
	}
	`}
`;
export const InputContainerSmall = styled(BodySecondary) `
	${inputCss};
	input {
		min-height: 20px;
		&::-webkit-outer-spin-button,
		&::-webkit-inner-spin-button {
			-webkit-appearance: none;
			margin: 0;
		}
	}
	${(props) => props.height && props.type !== 'multiline' ? { height: props.height } : {}};
`;
export const InputHeader = styled.div `
	display: flex;
	justify-content: space-between;
	margin-bottom: 8px;
	.label__container {
		display: flex;
		align-items: center;
		gap: 2px;
		> div:first-child {
			${(props) => props.invalid ? `color: ${COLORS.content.negative} !important` : ''};
		}
	}

	span {
		color: ${COLORS.content.negative};
		padding-left: 4px;
	}
`;
export const MaxCharStyle = styled(BodySecondary) `
	color: ${COLORS.content.secondary} !important;
	margin-top: ${(props) => (props.position === 'BOTTOM' ? '8px' : '0px')};
`;
export const InputFooter = styled(BodyCaption) `
	white-space: pre-wrap;
	margin-top: 8px;
	color: ${(props) => props.invalid
    ? COLORS.content.negative
    : COLORS.content.secondary} !important;
	/* position: absolute; */
	/* left: 0px;
	top: 100%; */
	display: flex !important;
	gap: 6px;
	min-height: 16px;
	> svg {
		width: 16px;
		height: 16px;
	}
`;
export const RootContainer = styled.div `
	${(props) => (props.width ? `width: ${props.width}` : '')};
	${(props) => props.height && props.type == 'multiline' ? `height: ${props.height}` : ''};
	${(props) => props.state === 'disabled' || props.state === 'disabled-invalid'
    ? css `
					opacity: 0.5;
					pointer-events: none;
			  `
    : ''};
	display: flex;
	flex-direction: column-reverse;
	position: relative;
	.truncate-class {
		max-width: 180px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.flex-align-center {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
`;
export const PrefixHolder = styled(BodyPrimary) `
	overflow: unset;
	margin-left: ${(props) => props.variant && ['small', 'x-small'].includes(props.variant)
    ? ''
    : '16px'};
	font-size: ${(props) => props.variant === 'x-small'
    ? '12px'
    : props.variant === 'small'
        ? '14px'
        : '16px'};
	line-height: ${(props) => props.variant === 'x-small'
    ? '16px'
    : props.variant === 'small'
        ? '20px'
        : '24px'};
`;
export const SuffixHolder = styled(BodyPrimary) `
	overflow: unset;
	margin-right: ${(props) => props.variant && ['small', 'x-small'].includes(props.variant)
    ? ''
    : '16px'};
	font-size: ${(props) => props.variant === 'x-small'
    ? '12px'
    : props.variant === 'small'
        ? '14px'
        : '16px'};
	line-height: ${(props) => props.variant === 'x-small'
    ? '16px'
    : props.variant === 'small'
        ? '20px'
        : '24px'};
`;
//# sourceMappingURL=Input.styled.js.map